import React, { Component } from 'react';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';
import { Player } from '@lottiefiles/react-lottie-player';
import styles from './_desktopSetupLoaderModal.module.scss';
import './_desktopSetupLoaderModalModal.scss';

export default class DesktopSetupLoaderModal extends Component {
  render() {
    const { isModalVisible } = this.props;
    return (
      <div className={cx(styles['desktop-cancel-purchase'])}>
        <Modal show={isModalVisible} size="lg" centered>
          <div className="desktop-cancel-purchase">
            <div>
              <div className="cancel-purchase-title">SAVINGS PLAN SETUP</div>

              <div className="cancel-purchase-rewards">
                <div className="cancel-purchase-not-leaving">
                  This may take a few minutes, please do not refresh or close this tab
                </div>
                <Player
                  autoplay
                  loop
                  keepLastFrame
                  src="https://assets6.lottiefiles.com/packages/lf20_5xjxnhli.json"
                  className="sand-clock"
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
